import { memo } from 'react';

import { TranslateString } from '@/types/translation.types';
import { updateTranslateKey } from '@/utils/update-translation-key';
import InputWithOverlay from '@ui/input-with-overlay/input-with-overlay';

type TEditTitleProps = {
  jobTitle: TranslateString | undefined;
  onChange: (value: TranslateString) => void;
  baseLanguage: string;
  language: string;
};

const EditTitle = memo(({ jobTitle, onChange, baseLanguage, language }: TEditTitleProps) => {
  return (
    <label htmlFor="title" className="flex-1 flex-column gap-4 width-100-percent">
      <InputWithOverlay
        label="Title *"
        dirtyError={({ dirty, setHasError }) => {
          const hasError = dirty && !jobTitle?.base?.trim().length;
          setHasError(hasError);
        }}
        designSize="medium"
        inputProps={{
          id: 'title',
          value: jobTitle?.base || '',
          onChange: (e) => {
            onChange(
              updateTranslateKey({
                translateString: jobTitle ?? { base: '', changed: '' },
                input: e.target.value,
                baseLanguage,
                language,
              })
            );
          },
          placeholder: 'Add job title',
        }}
      />
    </label>
  );
});

EditTitle.displayName = 'EditTitle';

export default EditTitle;
